import React from 'react';
import ContractDetailsComponent from './contract-details.component';

function ContractDetails() {
    return <ContractDetailsComponent />;
}

export default ContractDetails;
